export const getModulesConfig = (imageHandler, expanded = false) => {
    const basicToolbar = [
        ['bold', 'italic', 'underline'],
        [{'color': 'custom-picker'}, {'background': 'custom-picker'}],
        ['variableDropdown']
    ];

    const expandedToolbar = [
        [{'header': [1, 2, 3, 4, 5, 6, false]}],
        ['bold', 'italic', 'underline', 'strike'],
        [{'color': 'custom-picker'}, {'background': 'custom-picker'}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        [{'align': []}, {'direction': 'rtl'}],
        ['blockquote', 'code-block'],
        ['link', 'image', 'video'],
        ['emoji'],
        ['variableDropdown']
    ];

    return {
        toolbar: {
            container: expanded ? expandedToolbar : basicToolbar,
            handlers: expanded ? {
                image: imageHandler
            } : {}
        },
        'emoji-toolbar': expanded,
        'emoji-textarea': false,
        'emoji-shortname': expanded,
        history: {
            delay: 500,
            maxStack: 100,
            userOnly: true,
        }
    };
};

